import {useLocation} from "react-router-dom";

export function usePagePathSegment() {
    let location = useLocation();
    let pathParts = location.pathname ? location.pathname.split('/') : [];
    let pagePathSegment;
    if (pathParts.length > 1) {
        pagePathSegment = pathParts[1];
    } else {
        pagePathSegment = ('' + location.pathname).replace(new RegExp('/', 'g'), '')
    }
    return pagePathSegment;
}
